import type { ReactNode } from 'react';
import { Search } from 'lucide-react';

export function PageHeader({
  title,
  subtitle,
  search,
  onSearch,
  searchPlaceholder = 'Buscar…',
  actions,
}: {
  title: string;
  subtitle?: string;
  search?: string;
  onSearch?: (v: string) => void;
  searchPlaceholder?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4 border-b border-line bg-white px-8 py-5">
      <div>
        <h1 className="text-xl font-semibold text-ink">{title}</h1>
        {subtitle && <p className="mt-0.5 text-sm text-slate">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-3">
        {onSearch && (
          <div className="relative">
            <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate" />
            <input
              value={search}
              onChange={(e) => onSearch(e.target.value)}
              placeholder={searchPlaceholder}
              className="h-10 w-64 rounded-xl border border-line bg-white pl-9 pr-3 text-sm text-ink placeholder:text-slate/60 focus:border-brand-orange focus:outline-none focus:ring-2 focus:ring-brand-orange/20"
            />
          </div>
        )}
        {actions}
      </div>
    </div>
  );
}
